import { render, staticRenderFns } from "./CountdownSlider.vue?vue&type=template&id=6d4ec0e6"
import script from "./CountdownSlider.vue?vue&type=script&lang=js"
export * from "./CountdownSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports